export default {
	'ddc.link.generic': [
		// remove these events so client does not duplicate tagging coming from MyCars links clicks
		{
			insertion: 'unshift',
			logic: ({ eventData }) =>
				['button-save', 'button-trackPrice'].includes(
					eventData?.attributes?.['data-testid']
				) ||
				eventData?.attributes?.['data-cy'] === 'get-notified-button'
		}
	],
	widgetUserEvent: [
		{
			logic: {
				'eventData.action': 'clicked',
				'eventData.element': 'Save button',
				'eventData.result': 'Vehicle saved'
			},
			payload: {
				shared: ['[[window._dl]]'],
				site_events: {
					save_vehicle: true
				}
			}
		},
		{
			logic: {
				'eventData.action': 'clicked',
				'eventData.result': 'Email Signup for Price Alert Notification'
			},
			payload: {
				shared: ['[[window._dl]]'],
				site_events: {
					get_price_alerts: true
				}
			}
		}
	]
};
